import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  Activities,
  Activity,
  CorporateTrackingStatus,
  CorporateTrackingStatusData,
} from './corporate-tracking-status.interface';
import { ApiService } from '@services/api.service';

@Component({
  selector: 'ew-corporate-tracking-status',
  templateUrl: './corporate-tracking-status.component.html',
  styleUrl: './corporate-tracking-status.component.scss',
})
export class CorporateTrackingStatusComponent implements OnChanges {
  status: number = 1;
  activities: Activities = {};
  ACTIVITIES_URL!: string;
  @Input() corporateTrackingStatusData!: CorporateTrackingStatusData;

  constructor(private API: ApiService) {}

  /**
   * changes in inputs
   * @param changes changes input
   * @author Martin Batun Tec.
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['corporateTrackingStatusData'].currentValue) {
      this.corporateTrackingStatusData =
        changes['corporateTrackingStatusData'].currentValue;
      this.status = this.setStatus(this.corporateTrackingStatusData.status);
      this.getActivity();
    }
  }

  /**
   * returns number status.
   * @param value CorporateTrackingStatus
   * @author Martin Batun Tec.
   */
  setStatus(value: CorporateTrackingStatus): number {
    switch (value) {
      case 'CANCELED':
        return 0;
      case 'OPEN':
        return 1;
      case 'PENDING_AUTHORIZATION':
        return 2;
      case 'AUTHORIZED':
        return 3;
      case 'IN_TRANSIT':
        return 4;
      case 'RECEIVED':
        return 5;
      case 'CREDITED':
        return 6;
      default:
        return 1;
    }
  }

  /**
   * returns the date for the states.
   * @author Martin Batun Tec.
   */
  getActivity(): void {
    this.ACTIVITIES_URL =
      this.corporateTrackingStatusData.type === 'TOP_UP'
        ? `v1/invoices/${this.corporateTrackingStatusData.paymentRequestId}/activity`
        : `v1/commissions/${this.corporateTrackingStatusData.paymentRequestId}/activity`;

    this.API.get(this.ACTIVITIES_URL).subscribe((data: any) => {
      data.records.forEach(
        (
          element: {
            status: CorporateTrackingStatus;
          } & Activity,
        ) => {
          this.activities[element.status] = {
            modifiedAt: element.modifiedAt,
            modifiedBy: element.modifiedBy,
          };
        },
      );
    });
  }
}
